import { Routes } from '@angular/router';
import { signedInGuard, SignedOutComponent } from 'shared';
import { accessRightGuard, clientScreensGuard, supplierEmployeeGuard } from '@crowndesk-core/access-rights/access-right.guard';
import { CrowndeskAccessRight } from '@crowndesk-core/access-rights/access-rights';

export const routes: Routes = [
  { path: 'signed-out', component: SignedOutComponent },
  {
    path: 'dashboard',
    canActivate: [signedInGuard, clientScreensGuard],
    loadChildren: () => import('./crowndesk-features/dashboard/routes').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: 'clients',
    canActivate: [signedInGuard, clientScreensGuard],
    loadChildren: () => import('./crowndesk-features/company-info/routes').then((m) => m.COMPANY_ROUTES),
  },
  {
    path: 'documents',
    canActivate: [signedInGuard, clientScreensGuard],
    loadChildren: () => import('./crowndesk-features/documents/routes').then((m) => m.DOCUMENT_ROUTES),
  },
  {
    path: 'products',
    canActivate: [signedInGuard, clientScreensGuard],
    loadChildren: () => import('./crowndesk-features/products/routes').then((m) => m.PRODUCT_ROUTES),
  },
  {
    path: 'tools',
    canActivate: [signedInGuard, clientScreensGuard],
    loadChildren: () => import('./crowndesk-features/tools/routes').then((m) => m.TOOL_ROUTES),
  },
  {
    path: 'company_revenue',
    // The revenue statistics are only for CrownDesk admins (the api answers 403 to other employees)
    canActivate: [signedInGuard, clientScreensGuard, accessRightGuard(CrowndeskAccessRight.IS_CROWNDESK_ADMIN)],
    loadChildren: () => import('./crowndesk-features/company-revenue/routes').then((m) => m.COMPANY_REVENUE_ROUTES),
  },
  // The supplier employee part; supplier employees are kept out of the client screens above
  {
    path: 'backorders',
    canActivate: [signedInGuard, supplierEmployeeGuard],
    loadChildren: () => import('./crowndesk-features/backorders/routes').then((m) => m.BACKORDER_ROUTES),
  },
  {
    path: 'sales_data',
    canActivate: [signedInGuard, clientScreensGuard, accessRightGuard(CrowndeskAccessRight.BILLING)],
    loadChildren: () =>
      import('./crowndesk-features/my-numbers/sales-data/sales-data-routes').then((m) => m.SALES_DATA_ROUTES),
  },
  {
    path: 'stock_sales_reports',
    canActivate: [signedInGuard, clientScreensGuard, accessRightGuard(CrowndeskAccessRight.BILLING)],
    loadChildren: () =>
      import('./crowndesk-features/my-numbers/stock-sales-report/stock-sales-report-routes').then(
        (m) => m.STOCK_SALES_REPORT_ROUTES,
      ),
  },
  {
    path: 'newsletters',
    canActivate: [signedInGuard, clientScreensGuard],
    loadChildren: () => import('./crowndesk-features/newsletters/routes').then((m) => m.NEWSLETTER_ROUTES),
  },
  {
    path: 'users',
    canActivate: [signedInGuard],
    loadChildren: () => import('./crowndesk-features/user-settings/routes').then((m) => m.USER_SETTINGS_ROUTES),
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'dashboard' },
];
